export const initializeEngagementForm = () => {
    let addressInputbox = document.getElementById('address-input-box');
    let inlineFormBuy = document.getElementById('inline-form-buy');
    let coreLogicIntegration = document.getElementById('daintegration');

    let observer = new MutationObserver((mutationsList, observer) => {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {

                let corelogicForm = document.querySelector('.da_address_form');

                if (corelogicForm) {
                    inlineFormBuy.appendChild(corelogicForm)
                }

            }
        }
    });

    if( coreLogicIntegration ) {
        // Start observing changes to the corelogic integration
        observer.observe(coreLogicIntegration, { childList: true, subtree: true });
    }
    
}

export const engagementToolTabTitles = () => {
    console.log('engaging tabs');
    const _titles = document.querySelectorAll('.tab-title');

    document.querySelectorAll('[data-bs-toggle="tab"]').forEach(_tab => {
        _tab.addEventListener('show.bs.tab', function (e) {
            let targetClass = _tab.dataset.bsTitle
            let pane = document.querySelector(targetClass);

            _titles.forEach(_title => { _title.classList.remove('show'); _title.classList.remove('active'); })

            pane.classList.add('show');
            pane.classList.add('active');

        })
    })
}